import 'codemirror/mode/javascript/javascript';

import { Inject } from '@rxdi/core';
import { Component, html, LitElement, property } from '@rxdi/lit-html';
import CodeMirror from 'codemirror';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { EditorCss } from './editor.css';
import { EditorProvider } from './editor.provider';
import { MaterialTheme } from './themes/material';

/**
 * @customElement code-mirror
 *
 */
@Component({
  selector: 'code-mirror',
  styles: [EditorCss, MaterialTheme],
  template(this: CodeMirrorComponent) {
    return html` <div class="container"></div>`;
  },
})
export class CodeMirrorComponent extends LitElement {
  private subscription: Subscription;
  @property()
  value: string;
  @Inject(EditorProvider)
  private editorProvider: EditorProvider;
  OnUpdateFirst() {
    this.editorProvider.setInstance(
      CodeMirror(this.shadowRoot.querySelector('.container'), {
        lineNumbers: true,
        value: this.value,
        mode: 'javascript',
        autocorrect: true,
        theme: 'material',
        // addModeClass: true,
      })
    );
    this.subscription = this.change()
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((detail) => this.dispatchEvent(new CustomEvent('changed', { detail })));
  }

  OnUpdate() {
    const instance = this.editorProvider.getInstance();
    if (instance) {
      instance.setValue(this.value);
    }
  }

  change() {
    return new Observable<string>((observer) => {
      const doc = this.editorProvider.getInstance().getDoc();

      doc.on('change', () => {
        observer.next(doc.getValue());
      });

      return () => observer.complete();
    });
  }

  OnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
